import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface DialogErrorProps {
  onClose: () => void;
  open: boolean;
  onOk: () => void;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    btnAction: {
      height: 48
    }
  }),
  { name: "DialogConfirmOrder" }
);

const DialogConfirmOrder: React.FC<DialogErrorProps> = ({
  onClose,
  open,
  onOk
}) => {
  const intl = useIntl();
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      disableScrollLock={true}
    >
      <DialogTitle>
        <MyTypography variant={"h6"}>
          {intl.formatMessage({ defaultMessage: "ยืนยันคำสั่งซื้อ" })}
        </MyTypography>
      </DialogTitle>
      <DialogContent>
        <MyTypography variant={"body2"}>
          {intl.formatMessage({
            defaultMessage:
              "กรุณากด “ยืนยัน” เพื่อสร้างคำสั่งซื้อ หรือกด “ยกเลิก” เพื่อกลับไป"
          })}
        </MyTypography>
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          color={"secondary"}
          variant={"outlined"}
          className={classes.btnAction}
          fullWidth={true}
          onClick={onClose}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          color={"secondary"}
          variant={"contained"}
          className={classes.btnAction}
          fullWidth={true}
          onClick={onOk}
        >
          <FormattedMessage defaultMessage={"ยืนยัน"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmOrder;
